import React, { useCallback, useEffect, useRef, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import TranslatedText from "../../../utils/Translate"
import { Checkbox, IconButton, Modal, Paper, Snackbar, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { debounce } from "../../../utils/debounce"
import { clientLanguageOptions, getClientLangByCode, languageOptions } from "../../../utils/LanguageList"
import SendIcon from '@mui/icons-material/Send';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import Chip from "@mui/material/Chip";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';


export default function Prompter() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const language = useSelector(
        (state: any) => state.auth.authData.language
    );


    const [conversationtemplates, setConversationtemplates] = useState([])
    const [partners, setPartners] = useState([])

    const [prompterData, setPrompterData] = useState({

    });


    // Пример базы знаний с id
    const knowledgeBase = [
        {
            id: 1,
            section: "Тарифы",
            content: `
               *В рамках данного Тарифного плана новые клиенты – клиенты, у которых в течение 90 (девяноста) календарных дней, предшествовавших дате открытия счета, отсутствовали открытые в Банке срочные вклады, а также накопительные счета в рублях РФ либо совокупный остаток по всем действовавшим в указанном периоде вкладам и накопительным счетам был менее 3 000 руб. Повышенная ставка начисляется в первом отчетном периоде и в следующем за ним календарном месяце. Повышенная ставка не подлежит изменению в течение первого и следующего за ним отчетного периода.
Справочная информация:
Накопительный счёт и вклад — это не одно и то же, у них разные условия и функционал.
Вклад — это счёт, на который кладут деньги на определённый срок под проценты. Клиент передаёт в банк фиксированную сумму денег с целью получить доход при начислении процентов.
Накопительный счёт — это депозитный счёт, которым владелец может распоряжаться без ограничений. Он открывается на бессрочный период времени, и деньги с него можно снимать в любой момент.
При открытие вклада, определённая ставка фиксируется в договоре на весь срок вклада, и банк не сможет изменить её до даты продления. У накопительного счёта ставка может меняться как в большую, так и в меньшую сторону по инициативе банка. Вклад открывается на определённый срок, а накопительный счёт — нет.
Новые клиенты – клиенты, у которых в течение 90 (девяноста) календарных дней, предшествовавших дате открытия счета, отсутствовали открытые в Банке срочные вклады, а также накопительные  счета в рублях РФ либо совокупный остаток по всем действовавшим в указанном периоде вкладам и накопительным счетам был менее 3 000 руб.
            `
        },
        {
            id: 2,
            section: "Поддержка",
            content: `
                Каналы поддержки:
                - Онлайн-чат на сайте (24/7)
                - Электронная почта: support@example.com
                - Телефон: 8-800-123-45-67 (Пн-Пт 9:00-18:00)
                Часто задаваемые вопросы:
                - Как восстановить пароль?
                - Как изменить тариф?
                Время ответа:Обычно в течение 15 минут.
            `
        },
        {
            id: 3,
            section: "Продукты",
            content: `
            1: Решение для автоматизации продаж.
            2: Система аналитики и отчетности.
            3: Мобильное приложение для управления задачами.
            Преимущества: Простота внедрения, интеграция с популярными сервисами, высокая безопасность.
            Демо-доступ: Доступен по запросу.
            `
        },
    ];

    // Функция для поиска раздела по названию
    function findKbSectionByName(name: string) {
        return knowledgeBase.find(kb => kb.section === name);
    }

    // Пример подсказок для клиента
    function getPromptForClientMessage(text: string) {
        const kbSections: { id: number, name: string }[] = [];
        let prompt = "Ответьте на вопрос клиента максимально подробно и вежливо.";

        if (text.toLowerCase().includes("тариф")) {
            const kb = findKbSectionByName("Тарифы");
            if (kb) kbSections.push({ id: kb.id, name: kb.section });
            prompt = "Расскажите подробнее о тарифе 'Премиум', его преимуществах и стоимости.";
        }
        if (text.toLowerCase().includes("продукт")) {
            const kb = findKbSectionByName("Продукты");
            if (kb) kbSections.push({ id: kb.id, name: kb.section });
            prompt = "Уточните, какой продукт интересует клиента, и расскажите о его возможностях.";
        }
        if (text.toLowerCase().includes("поддержка")) {
            const kb = findKbSectionByName("Поддержка");
            if (kb) kbSections.push({ id: kb.id, name: kb.section });
            prompt = "Сообщите клиенту о доступных каналах поддержки.";
        }
        return { prompt, kbSections };
    }

    // Тип для сообщений чата, позволяющий опциональное свойство kbSections
    type ChatMessage = {
        from: string;
        text: string;
        kbSections?: { id: number; name: string }[];
    };

    // Состояние для сообщений чата и поля ввода
    const [chatMessages, setChatMessages] = useState<ChatMessage[]>([
        { from: 'operator', text: 'Здравствуйте! Чем могу помочь?' },
        { from: 'client', text: 'Здравствуйте! Мне нужна информация о вашем продукте.' },
        { from: 'prompter', text: 'Конечно! Какой продукт вас интересует?' },
        { from: 'operator', text: 'Конечно! Какой продукт вас интересует?' },
        { from: 'client', text: 'Интересует тариф "Премиум".' },
        { from: 'prompter', text: 'Тариф «Премиум» включает безлимитный доступ, приоритетную скорость, расширенные функции и поддержку и стоит всего 1990₽ в месяц. Давайте подключим?.', kbSections: [{ id: 1, name: 'Тарифы' }, { id: 3, name: 'Продукты' }] },
    ]);
    const [inputValue, setInputValue] = useState("");

    // Новое состояние для промптера
    const [prompterMessages, setPrompterMessages] = useState([
        { from: 'operator', text: 'Сколько всего видов тарифов?' },
        { from: 'prompter', text: 'Всего 3 тарифа: "Базовый", "Премиум", "Платинум"', kbSections: [{ id: 1, name: 'Тарифы' }] }
    ]);
    const [prompterInputValue, setPrompterInputValue] = useState("");

    const [isPrompterSpeek, setPrompterSpeek] = useState(false);


    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title


    useEffect(() => {
        dispatch(setCurrentPage('Prompter'))
    }, [dispatch]);



    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        setPrompterData({ ...prompterData, mode: newAlignment });
    };

    const handleClearPrompterChat = () => {
        setPrompterMessages([]);
    };




    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                alert("ERR_NETWORK")
            }
        }
    }


    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                alert("ERR_NETWORK")
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        getConversationtemplates();
        getPartners()
    }, [])

    const handleDebounceChange = useCallback(
        debounce((set: any) => {
            setPrompterData((prevState: any) => (set));
        }, 200),
        []
    );




    // Обработка отправки сообщения оператором (Conversation)
    const handleSend = () => {
        if (!inputValue.trim()) return;
        setChatMessages(prev => [
            ...prev,
            { from: 'operator', text: inputValue }
        ]);
        setInputValue("");
    };

    // Обработка отправки сообщения в промптер
    const handlePrompterSend = () => {
        if (!prompterInputValue.trim()) return;
        setPrompterMessages(prev => [
            ...prev,
            { from: 'operator', text: prompterInputValue }
        ]);
        setPrompterInputValue("");
    };

    // Автоматическая подсказка после сообщения клиента
    useEffect(() => {
        const lastMsg = chatMessages[chatMessages.length - 1];
        if (lastMsg && lastMsg.from === "client") {
            const { prompt, kbSections } = getPromptForClientMessage(lastMsg.text);
            setChatMessages(prev => [
                ...prev,
                {
                    from: "prompter",
                    text: `Подсказка: ${prompt}`,
                    kbSections // массив разделов
                }
            ]);
        }
        // eslint-disable-next-line
    }, [chatMessages]);

    // Обработка Enter
    const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") handleSend();
    };

    // Обработка Enter для промптера
    const handlePrompterInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") handlePrompterSend();
    };

    const [kbModalOpen, setKbModalOpen] = useState(false);
    const [selectedKb, setSelectedKb] = useState<null | typeof knowledgeBase[0]>(null);

    // Добавьте состояние активности разговора
    const [isConnected, setIsConnected] = useState(false);

    // Функция для отключения
    const handleDisconnect = () => {
        setIsConnected(false);
        setActiveMode(null); // Сброс активного режима при отключении
        // Можно добавить очистку сообщений или другое поведение при отключении
    };

    // Измените тип состояния activeMode, чтобы поддерживать null
    const [activeMode, setActiveMode] = useState<'client' | 'prompter' | null>(null);

    // Реф для автоскролла окна сообщений суфлёра
    const prompterMessagesEndRef = useRef<HTMLDivElement | null>(null);

    // Прокрутка вниз при изменении сообщений суфлёра
    useEffect(() => {
        if (prompterMessagesEndRef.current) {
            prompterMessagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [prompterMessages]);



    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
                {/* Conversation */}
                <Paper
                    elevation={3}
                    sx={{
                        width: isConnected ? '40%' : '20%',
                        minWidth: isConnected ? 500 : 250,
                        maxWidth: isConnected ? 1200 : 400,
                        height: '80vh',
                        padding: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        background: "#f8fafc",
                        borderRadius: 4,
                        transition: 'width 0.5s, min-width 0.5s, max-width 0.5s',
                        boxShadow: activeMode === 'client' ? '0 0 0 5px #a084e8, 0 1px 4px rgba(25, 118, 210, 0.07)' : 8, // Меньше тень
                        '@media (max-width:1013px)': {
                            width: '100%',
                            minWidth: 'unset',
                            maxWidth: 'unset',
                            height: 'auto',
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography sx={{ fontWeight: 600, letterSpacing: 1 }} variant="h5">
                            <TranslatedText text={'Conversation'} />
                        </Typography>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleDisconnect}
                            disabled={!isConnected}
                        >
                            <TranslatedText text={'Disconnect'} />
                        </Button>
                    </Box>
                    {!isConnected ? (
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Paper
                                elevation={2}
                                sx={{
                                    p: 3,
                                    borderRadius: 3,
                                    background: '#f4f6fb',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                    minWidth: 220,
                                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.07)'
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        color: '#333',
                                        mb: 1,
                                        textAlign: 'center',
                                        letterSpacing: 0.5,
                                    }}
                                >
                                    Сейчас идёт активный разговор
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#888',
                                        mb: 2,
                                        textAlign: 'center',
                                    }}
                                >
                                    Вы можете присоединиться в любой момент.
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { setIsConnected(true); setActiveMode('client') }}
                                    sx={{
                                        borderRadius: 2,
                                        px: 3,
                                        fontWeight: 500,
                                        boxShadow: 'none',
                                        textTransform: 'none'
                                    }}
                                >
                                    Присоединиться к разговору
                                </Button>
                            </Paper>
                        </Box>
                    ) : (
                        <Box sx={{
                            flex: 1,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            borderRadius: 2,
                            p: 2,
                            minHeight: 0,
                            background: "#f4f6fb"
                        }}>
                            {chatMessages.map((msg, idx) => (
                                <Stack
                                    key={idx}
                                    direction={
                                        msg.from === 'operator'
                                            ? 'row-reverse'
                                            : msg.from === 'client'
                                                ? 'row'
                                                : 'row'
                                    }
                                    alignItems="flex-end"
                                    spacing={1}
                                    sx={{
                                        alignSelf:
                                            msg.from === 'operator'
                                                ? 'flex-end'
                                                : msg.from === 'client'
                                                    ? 'flex-start'
                                                    : 'center',
                                        maxWidth: msg.from === 'prompter' ? '90%' : '70%',
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            bgcolor:
                                                msg.from === 'operator'
                                                    ? '#673ab7'
                                                    : msg.from === 'client'
                                                        ? '#90caf9'
                                                        : '#c0d8c1',
                                            color:
                                                msg.from === 'operator'
                                                    ? '#fff'
                                                    : msg.from === 'client'
                                                        ? '#1565c0'
                                                        : '#333',
                                            width: 32,
                                            height: 32,
                                            fontSize: 18
                                        }}
                                    >
                                        {msg.from === 'operator'
                                            ? 'О'
                                            : msg.from === 'client'
                                                ? 'К'
                                                : 'С'}
                                    </Avatar>
                                    <Box>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: '#888',
                                                mb: 0.5,
                                                ml: msg.from === 'operator' ? 0 : 0.5,
                                                mr: msg.from === 'operator' ? 0.5 : 0,
                                                textAlign: msg.from === 'operator' ? 'right' : 'left'
                                            }}
                                        >
                                            {msg.from === 'operator'
                                                ? 'Оператор'
                                                : msg.from === 'client'
                                                    ? 'Клиент'
                                                    : 'Суфлёр'}
                                        </Typography>
                                        <Paper
                                            elevation={2}
                                            sx={{
                                                p: 1.5,
                                                background:
                                                    msg.from === 'operator'
                                                        ? '#ede7f6'
                                                        : msg.from === 'client'
                                                            ? '#e3f2fd'
                                                            : '#e8f5e9',
                                                color: '#222',
                                                fontStyle: msg.from === 'prompter' ? 'italic' : 'normal',
                                                borderRadius: 3,
                                                minWidth: 60,
                                                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.07)'
                                            }}
                                        >
                                            <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                                                {msg.text}
                                            </Typography>
                                            {/* Chips для разделов базы знаний */}
                                            {msg.from === 'prompter' && Array.isArray(msg.kbSections) && msg.kbSections.length > 0 && (
                                                <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                    {msg.kbSections.map(section => (
                                                        <Chip
                                                            key={section.id}
                                                            label={section.name}
                                                            // color="info"
                                                            size="small"
                                                            sx={{ fontWeight: 500, fontStyle: 'normal', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                const kb = knowledgeBase.find(k => k.id === section.id);
                                                                if (kb) {
                                                                    setSelectedKb(kb);
                                                                    setKbModalOpen(true);
                                                                }
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            )}
                                        </Paper>
                                    </Box>
                                </Stack>
                            ))}
                        </Box>
                    )}
                </Paper>

                {/* Prompter */}
                <Box
                    sx={{
                        width: isConnected ? '40%' : '60%',
                        minWidth: isConnected ? 500 : 700,
                        height: '80vh',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        transition: 'width 0.5s, min-width 0.5s',
                        '@media (max-width:1013px)': {
                            width: '100%',
                            minWidth: 'unset',
                            height: 'auto',
                        }
                    }}
                >
                    <Paper elevation={3} sx={{
                        padding: 2,
                        height: "100%",
                        minHeight: 200,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        borderRadius: 4,
                        background: "#f8fafc",
                        boxShadow: activeMode === 'prompter' ? '0 0 0 5px #a084e8, 0 1px 4px rgba(103,58,183,0.10)' : 8 // Меньше тень
                    }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography sx={{ fontWeight: 600, letterSpacing: 1 }} variant="h5">
                                <TranslatedText text={'Prompter'} />
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                               {isPrompterSpeek ? <Button
                                    variant="outlined"         
                                    onClick={() => setPrompterSpeek(false)}
                                >
                                    <VolumeUpIcon />
                                </Button> : 
                                 <Button
                                    variant="outlined"    
                                    onClick={() => setPrompterSpeek(true)}
                                >
                                    <VolumeOffIcon />
                                </Button>
                                }
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleClearPrompterChat}
                                >
                                    <ClearAllIcon />
                                </Button>

                            </Box>

                        </Box>
                        <Box sx={{
                            flex: 1,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            borderRadius: 3,
                            p: 2,
                            minHeight: 0,
                            background: "#f4f6fb"
                        }}>
                            {prompterMessages.length === 0 ? (
                                <Box sx={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#888',
                                    fontSize: 18,
                                    opacity: 0.8,
                                    textAlign: 'center'
                                }}>
                                    Сообщений ещё нет. Задайте вопрос суфлёру!
                                </Box>
                            ) :
                                (
                                    <>
                                    {prompterMessages.map((msg, idx) => (
                                        <Stack
                                            key={idx}
                                            direction={msg.from === 'operator' ? 'row-reverse' : 'row'}
                                            alignItems="flex-end"
                                            spacing={1}
                                            sx={{
                                                alignSelf: msg.from === 'operator' ? 'flex-end' : 'flex-start',
                                                maxWidth: '90%',
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: msg.from === 'operator' ? '#673ab7' : '#c0d8c1',
                                                    color: msg.from === 'operator' ? '#fff' : '#333',
                                                    width: 32,
                                                    height: 32,
                                                    fontSize: 18
                                                }}
                                            >
                                                {msg.from === 'operator' ? 'О' : 'С'}
                                            </Avatar>
                                            <Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        color: '#888',
                                                        mb: 0.5,
                                                        ml: msg.from === 'operator' ? 0 : 0.5,
                                                        mr: msg.from === 'operator' ? 0.5 : 0,
                                                        textAlign: msg.from === 'operator' ? 'right' : 'left'
                                                    }}
                                                >
                                                    {msg.from === 'operator' ? 'Оператор' : 'Суфлёр'}
                                                </Typography>
                                                <Paper
                                                    elevation={2}
                                                    sx={{
                                                        p: 1.5,
                                                        background: msg.from === 'operator' ? '#ede7f6' : '#e8f5e9',
                                                        color: '#222',
                                                        fontStyle: msg.from === 'prompter' ? 'italic' : 'normal',
                                                        borderRadius: 3,
                                                        minWidth: 60,
                                                        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.07)'
                                                    }}
                                                >
                                                    <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                                                        {msg.text}
                                                    </Typography>
                                                    {/* Chips для разделов базы знаний */}
                                                    {msg.from === 'prompter' && Array.isArray(msg.kbSections) && msg.kbSections.length > 0 && (
                                                        <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                            {msg.kbSections.map(section => (
                                                                <Chip
                                                                    key={section.id}
                                                                    label={section.name}
                                                                    // color="info"
                                                                    size="small"
                                                                    sx={{ fontWeight: 500, fontStyle: 'normal', cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        const kb = knowledgeBase.find(k => k.id === section.id);
                                                                        if (kb) {
                                                                            setSelectedKb(kb);
                                                                            setKbModalOpen(true);
                                                                        }
                                                                    }}
                                                                />
                                                            ))}
                                                        </Box>
                                                    )}
                                                </Paper>
                                            </Box>
                                        </Stack>
                                    ))}
                                    {/* Элемент для прокрутки вниз */}
                                    <div ref={prompterMessagesEndRef} />
                                    </>
                                )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1, mt: 'auto', pt: 2 }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Введите сообщение для суфлёра..."
                                value={prompterInputValue}
                                onChange={e => setPrompterInputValue(e.target.value)}
                                onKeyDown={handlePrompterInputKeyDown}
                                size="small"
                                sx={{
                                    background: "#fff",
                                    borderRadius: 2
                                }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePrompterSend}
                                sx={{
                                    minWidth: 48,
                                    px: 2,
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(103,58,183,0.10)'
                                }}
                            >
                                <SendIcon />
                            </Button>
                        </Box>
                    </Paper>
                    <Paper
                        elevation={3}
                        sx={{
                            padding: 2,
                            height: 450,
                            background: "#f8fafc",
                            borderRadius: 4,
                            boxShadow: 8
                        }}
                    >
                        <Typography sx={{ width: '100%', mb: 2, fontWeight: 600, letterSpacing: 1 }} variant="h5">
                            <TranslatedText text={'База знаний'} />
                        </Typography>
                        <Box sx={{ p: 1, gap: 2, display: 'flex', flexDirection: 'column' }}>
                            {knowledgeBase.map((kb, idx) => (
                                <Paper
                                    key={idx}
                                    sx={{
                                        p: 2,
                                        background: '#f4f6fb',
                                        borderRadius: 3,
                                        cursor: 'pointer',
                                        transition: 'box-shadow 0.2s',
                                        boxShadow: 3,

                                        '&:hover': { boxShadow: 6, background: '#e3f2fd' }
                                    }}
                                    onClick={() => { setSelectedKb(kb); setKbModalOpen(true); }}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                        {kb.section}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#555',
                                            opacity: 0.85,
                                            fontSize: 15,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '100%',
                                        }}
                                    >
                                        {kb.content.replace(/\n/g, ' ').slice(0, 120)}...
                                    </Typography>
                                </Paper>
                            ))}
                        </Box>
                    </Paper>
                </Box>
            </Box>
            {/* Кнопка-переключатель режимов */}
            <Box sx={{
                position: 'fixed',
                bottom: 24,
                left: 0,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                zIndex: 1300
            }}>
                <Paper elevation={6} sx={{ borderRadius: 8, p: 1, display: 'flex', gap: 2 }}>
                    {isConnected ? (
                        <>
                            <Button
                                variant={activeMode === 'client' ? 'contained' : 'outlined'}
                                sx={{
                                    fontWeight: 600,
                                    bgcolor: activeMode === 'client' ? '#673bb7' : undefined,
                                    color: activeMode === 'client' ? '#fff' : undefined,
                                    boxShadow: activeMode === 'client' ? '0 0 4px #673bb7' : undefined,
                                    borderRadius: 3,
                                    px: 3
                                }}
                                onClick={() => setActiveMode('client')}
                            >
                                Говорить Клиенту
                            </Button>
                            <Button
                                variant={activeMode === 'prompter' ? 'contained' : 'outlined'}
                                sx={{
                                    fontWeight: 600,
                                    bgcolor: activeMode === 'prompter' ? '#673bb7' : undefined,
                                    color: activeMode === 'prompter' ? '#fff' : undefined,
                                    boxShadow: activeMode === 'prompter' ? '0 0 4px #673bb7' : undefined,
                                    borderRadius: 3,
                                    px: 3
                                }}
                                // Нельзя отключить activeMode если isConnected true
                                onClick={() => {
                                    if (activeMode !== 'prompter') {
                                        setActiveMode('prompter');
                                    }
                                    // если уже prompter и isConnected true — ничего не делаем
                                }}
                            >
                                Говорить Суфлёру
                            </Button>
                        </>
                    ) : (
                        <Button
                            variant={activeMode === 'prompter' ? 'contained' : 'outlined'}
                            sx={{
                                fontWeight: 600,
                                bgcolor: activeMode === 'prompter' ? '#673bb7' : undefined,
                                color: activeMode === 'prompter' ? '#fff' : undefined,
                                boxShadow: activeMode === 'prompter' ? '0 0 4px #673bb7' : undefined,
                                borderRadius: 3,
                                px: 3
                            }}
                            // Можно отключить activeMode если isConnected false
                            onClick={() =>
                                setActiveMode(activeMode === 'prompter' ? null : 'prompter')
                            }
                        >
                            Говорить Суфлёру
                        </Button>
                    )}
                </Paper>
            </Box>

            {/* Модальное окно для выбранного раздела */}
            <Modal open={kbModalOpen} onClose={() => setKbModalOpen(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '80vw',
                    bgcolor: '#f8fafc',
                    borderRadius: 4,
                    boxShadow: 24,
                    p: 3,
                    outline: 'none',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
                            {selectedKb?.section}
                        </Typography>
                        <IconButton onClick={() => setKbModalOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {selectedKb?.content}
                    </Typography>
                </Box>
            </Modal>
        </Box>
    )
}







